import type { LanguageKey } from "../api/types";

/**
 * Sort the language keys by score, descending. Ties are broken by the order
 * of `languageOrder` (which is the canonical backend ordering), mirroring
 * the backend's `rank_languages` tie-break so the frontend and backend agree
 * on "who is ranked #1" in edge cases (e.g. two languages scoring 3/6).
 */
export function rankedByScore(
  languageOrder: LanguageKey[],
  scores: Record<LanguageKey, number>,
): LanguageKey[] {
  const positions = new Map(languageOrder.map((k, i) => [k, i] as const));
  return [...languageOrder].sort((a, b) => {
    const diff = (scores[b] ?? 0) - (scores[a] ?? 0);
    if (diff !== 0) return diff;
    return (positions.get(a) ?? 0) - (positions.get(b) ?? 0);
  });
}
